export default function ErrorPage({ reason }: { reason: string }) {
	return (
		<div className="flex flex-col items-center justify-center h-screen">
			<h1 className="text-2xl font-bold">Une erreur s'est produite</h1>
			<p className="text-gray-500">{reason}</p>
		</div>
	);
}
